/**
 * Reusable UI text constants for tooltips, labels, and messages
 */

export const BASELINE_COST_TOOLTIP =
  'Baseline Cost represents the standard cost agreed upon by FN and vendor. Any one-time discounts or special arrangements apply only to that PO. After the deal ends, costs revert to the baseline unless formally renegotiated.';

export const EXCLUSIVITY_TOOLTIP =
  'Product is only being sold to Fashion Nova.';

export const DELIVERY_DATE_TOOLTIP =
  'The earliest confirmed arrival date for custom-manufactured goods at our facility.';

export const STOCK_IHD_TOOLTIP =
  'Specify the earliest In-House Date (IHD) for existing, non-custom inventory.';
